exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb {\n  background: white; }\n  .breadcrumb .level {\n    display: inline-block;\n    padding: .7em 0 .6em 1.5em;\n    color: #2CC185;\n    text-decoration: none; }\n    .breadcrumb .level.inactive {\n      cursor: default; }\n    .breadcrumb .level:last-of-type {\n      font-weight: bold; }\n      .breadcrumb .level:last-of-type::after {\n        content: \"\"; }\n    .breadcrumb .level::after {\n      content: \">\";\n      margin-left: 1.5em;\n      position: relative;\n      font-weight: normal; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/BreadcrumbComponent/breadcrumb.component.scss
// module id = ./src/app/common/components/BreadcrumbComponent/breadcrumb.component.scss
// module chunks = main